export default __webpack_public_path__ + "static/media/student_myFavourite.149fe462.svg";